import { formatDate } from 'date-fns';
import type { ReactNode } from 'react';

interface CellInfo {
  title: ReactNode;
  content: ReactNode;
  date?: Date | number;
}

interface Props {
  invoice: CellInfo;
  refill: CellInfo;
}

export const TokenRefillTable = ({ invoice, refill }: Props) => {
  return (
    <div className="grid grid-rows-2 sm:grid-cols-2 sm:grid-rows-1 border border-bolt-ds-borderOutline rounded-lg">
      <div className="flex items-start justify-between gap-4 p-4">
        <div className="flex flex-col gap-1">
          <span className="text-bolt-ds-textTertiary text-xs">{invoice.title}</span>
          <span className="text-2xl font-semibold">{invoice.content}</span>
          {invoice.date && (
            <span>
              <span className="text-bolt-ds-textTertiary text-xs">Due on </span>
              <span className="text-sm font-semibold">{formatDate(new Date(invoice.date), 'MMMM dd, yyyy')}</span>
            </span>
          )}
        </div>

        <div className="flex shrink-0 items-center justify-center w-8 h-8 rounded-full border border-bolt-ds-borderOutline bg-bolt-ds-surfaceTwo">
          <span className="i-bolt:invoice-text-arrow-right-outline text-bolt-ds-iconSecondary" />
        </div>
      </div>

      <div className="flex items-start justify-between gap-4 p-4 border-l border-l-bolt-ds-borderOutline">
        <div className="flex flex-col gap-1">
          <span className="text-bolt-ds-textTertiary text-xs">{refill.title}</span>
          <span className="text-2xl font-semibold">{refill.content}</span>
          {refill.date && (
            <span>
              <span className="text-bolt-ds-textTertiary text-xs">On </span>
              <span className="text-sm font-semibold">{formatDate(new Date(refill.date), 'MMMM dd, yyyy')}</span>
            </span>
          )}
        </div>

        <div className="flex shrink-0 items-center justify-center w-8 h-8 rounded-full border border-bolt-ds-borderOutline bg-bolt-ds-surfaceTwo">
          <span className="i-bolt:custom-bolt text-bolt-ds-iconSecondary" />
        </div>
      </div>
    </div>
  );
};
